// extracted by mini-css-extract-plugin
export default {"amountInput":"NumericInput_amountInput__-RdrP","enterButton":"NumericInput_enterButton__4wynT"};